<template>
  <div :class="['container', { 'container-dark': theme_dark }]">

    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">赚积分</div>
      <div class="nav-right">
        <span class="nav-lable" @click="rules()">规则</span>
        <img src="../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>
    
    <div class="top ub ub-ver ub-pc">
      <div class="sum-score ub ub-pe"><span id="score-sum">0</span><a>积分</a></div>
      <ul class="ub ub-ac1">
          
          <li class="item ub ub-ver ub-pc ub-ac1">
            <span class="num">{{ sum_data.rec_score_chat }}</span>
            <span class="score">聊天积分</span>
          </li>

          <li class="y"></li>

          <li class="item ub ub-ver ub-pc ub-ac1">
            <span class="num">{{ sum_data.rec_onine_score }}</span>
            <span class="score">在线奖励</span>
          </li>

          <li class="y"></li>

          <li class="item ub ub-ver ub-pc ub-ac1">
            <span class="num">{{ sum_data.rec_score_other }}</span>
            <span class="score">其他</span>
          </li>
        </ul>
    </div>

    <div id="tasks-box" class="tasks-box">
      <ul class="tasks-list">
      
        <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/login.png" alt="">
            </div>
            <div class="score">
              <span class="reward">每日登录</span>
              <div class="integrals">积分+{{ task_login.score }},<span>{{ task_login.note }}</span></div>
            </div>
          <button class="btn btn-1" v-if="task_login.state == 1" >未完成</button>
          <button class="btn btn-2" v-if="task_login.state == 2" @click="receive(task_login)">待领取</button>
          <button class="btn btn-3" v-if="task_login.state == 3" @click="toast_Received()">已领取</button>
          </li>

        <div class="line"></div>

        <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/hello.png" alt="">
              </div>
              <div class="score">
                <span class="reward">打招呼奖励</span>
                <div class="integrals">积分+{{ task_hello.score }},<span>{{ task_hello.note }}</span></div>
              </div>
            <button class="btn btn-1" v-if="task_hello.state == 1" @click="goto_finish('hello')">+{{ task_hello.score }}积分</button>
            <button class="btn btn-2" v-if="task_hello.state == 2" @click="receive(task_hello)">待领取</button>
            <button class="btn btn-3" v-if="task_hello.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
          <div class="line"></div>

          <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/news.png" alt="">
              </div>
              <div class="score">
                <span class="reward">回复奖励</span>
                <div class="integrals">积分+{{ task_answer.score }},<span>{{ task_answer.note }}</span></div>
              </div>
            <button class="btn btn-1" v-if="task_answer.state == 1" @click="goto_finish('msg')">+{{ task_answer.score }}积分</button>
            <button class="btn btn-2" v-if="task_answer.state == 2" @click="receive(task_answer)">待领取</button>
            <button class="btn btn-3" v-if="task_answer.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
          

        <div class="line"></div>

        <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/gift-icon.png" alt="">
            </div>
            <div class="score">
              <div class="reward">礼物奖励</div>
              <div class="integrals">积分+{{ task_gift.score }},<span>{{ task_gift.note }}</span></div>
            </div>
          <button class="btn btn-1" v-if="task_gift.state == 1" @click="goto_finish('msg')">+{{ task_gift.score }}积分</button>
          <button class="btn btn-2" v-if="task_gift.state == 2" @click="receive(task_gift)">待领取</button>
          <button class="btn btn-3" v-if="task_gift.state == 3" @click="toast_Received()">已领取</button>
          </li>

          <div class="line"></div>

        <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/personal.png" alt="">
            </div>
            <div class="score">
              <span class="reward">在线奖励</span>
              <div class="integrals" v-html="task_online.tips"></div>
            </div>
            <button class="btn btn-2" v-if="task_online.state == 2" @click="receive_online(task_online)">待领取</button>
            <button class="btn btn-22" v-if="task_online.state == 22" @click="goto_finish('msg')">继续</button>
          </li>

        <div class="line"></div>

        <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/share.png" alt="">
            </div>
            <div class="score">
              <div class="reward-no">分享奖励(敬请期待)</div>
              <div class="integrals">积分+{{ task_share.score }},<span>{{ task_share.note }}</span></div>
            </div>
          <button class="btn btn-1" v-if="task_share.state == 1" @click="task_share_alert(task_share)">未完成</button>
          <button class="btn btn-2" v-if="task_share.state == 2" @click="receive(task_share)">待领取</button>
          <button class="btn btn-3" v-if="task_share.state == 3" @click="toast_Received()">已领取</button>
          </li>

      </ul>

      <ul class="chat-tasks ub ub-ver">
        <div class="middle-txt ub ub-pc ub-ac">
            <div class="d1"></div>
            <span>聊天收费设置</span>
            <div class="d2"></div>
        </div>
        <ul class="set-score ub ub-ac1">
          <li class="item ub ub-ac ub-pc" v-for="(item,index) in options" :key="index" :class="{ selected: item.on }" @click="choose(item.value)">
            <span>{{ item.label }}</span>
          </li>
        </ul>

        <div class="ub ub-ac ub-pc set_tips">
          <span>{{ selected_tips }}</span>
        </div>
        <div class="ub ub-ac ub-pc tips">
          <span>为了更好的用户体验，聊天收费设置每天限制修改1次</span>
        </div>

        <div class="ub ub-ver ub-ac ub-pc" >
          <div class="ub ub-ac ub-pc set_btn" @click="set_score()"><span>设置</span></div>
          
        </div>
      </ul>

      <ul>
        <li class="ub ub-ac ub-pc">
          <a class="more_set" @click="more_setMny()">更多收费设置，请前往：我的-->系统设置-->收费设置</a>
        </li>
      </ul>

      
    </div>
    
    <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
    <reward_score ref="show_reward_score" ></reward_score>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import Form from "../components/Form.vue";
import Score_Reward from "../components/Score_Reward.vue";
import * as tool from "../api/common";
export default {
  components: {
    dlg: Form,
    reward_score: Score_Reward
  },
  data() {
    return {
      task_login: {
          "title": "每日登录",
          "task_type": 1,
          "score": 50,
          "state": 2,
          "note": "每天登录就可领取"
      },
      task_hello: {
            "title": "打招呼奖励",
            "task_type": 2,
            "score": 100,
            "state": 1,
            "note": "完成10次打招呼就可领取"
        },
        task_answer: {
            "title": "回复奖励",
            "task_type": 3,
            "score": 100,
            "state": 1,
            "note": "完成10次回复就可领取"
        },
        task_share: {
            "title": "分享奖励",
            "task_type": 4,
            "score": 80,
            "state": 1,
            "note": "分享到朋友圈或者微信好友即可得奖励",
            "alert_txt": "点击右上角三个点，分享到朋友圈、微信好友、群聊天，即可领取该奖励，赶快去分享吧~<br/>该功能正在开发中，敬请期待~"
        },
        task_online: {
            "title": "在线奖励",
            "task_type": 5,
            "score": 10,
            "score_old": 10,
            "state": 2,
            "note": "",
            "tips": "积分+10，今日已在线1分钟，在线时间越长，奖励越高"
        },
        task_gift: {
            "title": "礼物奖励",
            "task_type": 6,
            "score": 100,
            "state": 1,
            "note": "收到任何一个礼物就可领取奖励哦",
            "alert_txt": "今日还未收到礼物，收到任意礼物后，即可领取该奖励，赶快去聊天吧~"
        },
        theme_dark: false,

        router_url: "",
        sum_data: {
          rec_onine_score: 0,
          rec_score_chat: 0,
          rec_score_other: 0,
          sum_score: 0
        },
        chat_mny_score: 0,
        selected_tips: "对方跟你聊天免金币，相应的你没有聊天积分收益",
        options: [
          { label: '免费', value: 0 ,tip: "对方跟你聊天免金币，相应的你没有聊天积分收益"},
          { label: '20金币/条', value: 20 ,tip: "对方跟你聊天需要支付20金币/消息，相应的你可获得20积分"},
          { label: '30金币/条', value: 30 ,tip: "对方跟你聊天需要支付30金币/消息，相应的你可获得30积分"}
        ],
        
    };
  },
  mounted() {
    tool.clear_online_action();
    tool.clear_chat_coin_hello();
    tool.clear_chat_coin_answer();

    this.loading("加载中...",5000);

    this.get_rec_score_chat();

    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_user();
    
    this.init();
  },
  beforeRouteEnter(to, from, next) {
   next(vm=>{
      vm.router_url = from.name;
    })
  },

  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo","act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init(){
      this.init_task_state();
      
      var uid = this.$store.state.uid;
      var self = this;
      this.get({
          url: "/App/GetTaskState?uid=" + uid,
          success: function (data) {
            self.$loading.close();
            self.init_serveData(data);
            setTimeout(()=>{
              self.init_sumData();
            },1000)
          },
          error: function (err){}
        });
        
    },

    init_task_state() {
      //未完成打招呼
      var loc_chat_hello = JSON.parse(localStorage.getItem("loc_chat_hello")) || [];
      if (loc_chat_hello.length >= 10) {
        this.task_hello.state = 2;
        this.task_hello.note = "恭喜你,任务已完成,点击领取奖励吧";
      }

      //未完成回复
      var loc_chat_answer = JSON.parse(localStorage.getItem("loc_chat_answer")) || [];
      if (loc_chat_answer.length >= 10) {
        this.task_answer.state = 2;
        this.task_answer.note = "恭喜你,任务已完成,点击领取奖励吧";
      }

      //未完成礼物奖励
      var is_first_gift = this.$store.state.objVal.is_first_gift;
        if (is_first_gift) {
          this.task_gift.state = 2;
          this.task_gift.note = "恭喜你，今日已成功收到一个礼物，点击领取奖励";
        }
    },

    init_serveData(serve_data) {
      //登录
      var task_login = serve_data.filter(item=> item.type_dtl == "任务奖励-登录");
        if (task_login.length > 0) {
          this.task_login.state = 3;
      } 
      //打招呼
      var task_hello = serve_data.filter(item=> item.type_dtl == "任务奖励-打招呼");
        if (task_hello.length > 0) {
          this.task_hello.state = 3;
          this.task_hello.note = "恭喜你,今日已成功领取100积分";
      }
      //回复
      var task_answer = serve_data.filter(item=> item.type_dtl == "任务奖励-回复");
        if (task_answer.length > 0) {
          this.task_answer.state = 3;
          this.task_answer.note = "恭喜你,今日已成功领取100积分";
      }

      //在线
      var task_online = serve_data.filter(item=> item.type_dtl == "任务奖励-在线");
        if (task_online.length > 0) {
          this.init_task_online(task_online);
        }
      
      //礼物
      var task_gift = serve_data.filter(item=> item.type_dtl == "任务奖励-礼物");
      if (task_gift.length > 0) {
        this.task_gift.state = 3;
        this.task_gift.note = "恭喜你，今日已领取100积分";
      }
    },

    init_user() {
      var uid = this.$store.state.uid;
      var self = this;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
            self.chat_mny_score = u.chat_mny_score;
            self.choose(u.chat_mny_score);
            self.show_footer(u);
        },
      });
    },

    //顶部统计
    init_sumData() {
      this.sum_data.rec_onine_score = this.task_online.score_old;
      var other_score = 0;
      if (this.task_login.state == 3) {
          other_score += Number(this.task_login.score);
      }
      if (this.task_gift.state == 3) {
          other_score += Number(this.task_gift.score);
      }
      if (this.task_hello.state == 3) {
        other_score += Number(this.task_hello.score);
      }
      if (this.task_answer.state == 3) {
        other_score += Number(this.task_answer.score);
      }

      this.sum_data.rec_score_other = other_score;
      this.sum_data.sum_score = Number(this.sum_data.rec_onine_score) + Number(this.sum_data.rec_score_chat) + Number(this.sum_data.rec_score_other);
      tool.roll_add_num(this.sum_data.sum_score, "score-sum", "");
    },

    show_footer(info) {
      if (info.chat_mny_score == 0) {
        var container = document.documentElement || document.body;
        container.scrollTop = container.scrollHeight;
      }
    },

    get_rec_score_chat() {
      var uid = this.$store.state.uid;
      var self = this;
      this.get({
          url: "/App/Get_ChatScore?uid=" + uid,
          success: function (data) {
            self.sum_data.rec_score_chat = data;
          },
          error: function (err){}
        });
    },

    init_task_online(serve_task) {
      var score_old = 10;

      if (serve_task.length > 0) {
        score_old = serve_task[0].amount;
      }
      
        //获取用户在线是时长
        var online_second = tool.get_online_time();
        var online_time = Math.floor(online_second / 60);
        var time_txt = "";
        if (online_time < 60) {
          time_txt = online_time + "分钟";
        } else {
          var hour = Math.floor(online_time / 60);
          var min = online_time - hour * 60;
          time_txt = hour + "小时" + min + "分钟";
        }

        var state = 22;
        var tips = "今日已在线"+time_txt+"，继续保持在线聊天，马上解锁新的在线奖励";

        var score_new = 0;
        //计算应得积分
        if (online_time <= 30) {
          score_new = 10 + (online_time * 5);
        }
        if (online_time > 30 && online_time <= 150) {
          score_new = 160 + (online_time - 30) * 3;
        } 
        if (online_time > 150) {
          score_new = 520 + (online_time - 150) * 2;
        }
        //计算状态
        if (score_new > score_old) {
          state = 2;
          tips = "积分+"+score_new+"，今日已在线"+time_txt+"，在线时间越长，奖励越高";
        }

        this.task_online = {
          "title": "在线奖励",
          "task_type": 5,
          "score": score_new,
          "score_old": score_old,
          "state": state,
          "note": '',
          "tips": tips,
        }
    },

    //获取奖励状态
    receive(task) {
      this.loading("领取中...",5000);
      var reward = {
          "type": task.title,
          "score": task.score,
          "tips": task.note,
          "path_name":"",
          "btn_name":"收下"
        }
      this.$refs.show_reward_score.show(reward);
      var uid = this.$store.state.uid;
      var self = this;
        self.get({
          url: "/App/ReceiveTaskScore?uid=" + uid +"&task_type=" + task.task_type +"&score=" + task.score,
          success: function (data) {
            self.$loading.close();
            if(data.state == 1){
              task.state = 3;
              task.score = task.score;
              self.act_reload_userinfo();
              self.init_sumData();
            }
          },
          error: function (err){}
        });
    },

    //领取在线奖励
    receive_online(task) {
        this.loading("领取中...",5000);
        var reward = {
          "type": task.title,
          "score": task.score,
          "tips": task.tips,
          "path_name":"",
          "btn_name":"收下"
        }
      this.$refs.show_reward_score.show(reward);
        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url: "/App/ReceiveTaskScore?uid=" + uid +"&task_type=5&score=" + task.score,
          success: function (data) {
            self.$loading.close();
            if (data.state == 1) {
              task.state = 22;
              task.score_old = task.score;
              self.act_reload_userinfo();
              self.init_sumData();
            }
          },
          error: function (err){}
        });
    },

    goto_finish(type) {
        if (type == "msg") {
          this.$router.push({name: "msg"});
          return true;
        }
        if (type == "hello") {
          this.$router.push({name: "hello_boy"});
        }
    },

    task_share_alert(item) {
        var h = item.alert_txt;
        var confirmText = "去完成";

        this.$refs.myForm.show(h, {
          type: "confirm",
          confirmText: confirmText,
          titleText: "分享奖励",
          data: ""
        });
    },

    formBehaviorFun(type, data) {
      if (type == "clickConfirm") {
        this.jump_to_chat();
      }
    },

    jump_to_chat() {
      if (this.router_url == "chart") {
        this.back();
      } else {
        this.$router.push({name: "msg"});
      }
      
    },

    toast_Received() {
      this.$toast.top("奖励已领取!，请不要再戳哦~"); //已领取奖励提示框
    },

    rules() {
      this.$router.push({name: "scorerules"});
    },

    loading(title,time) {
      var self = this;
        this.$loading(title);
        setTimeout(() => {
            self.$loading.close();
        }, time);
    },

    choose(selected_val) {
      var item;
      for (var i = 0; i < this.options.length; i++) {
        item = this.options[i];
        item.on = false;
        if (item.value == selected_val) {
          item.on = true;
          this.chat_mny_score = selected_val;
          this.selected_tips = item.tip;
        }
      }
    },

    set_score() {
      var loc_set_chatScore = localStorage.getItem("loc_set_chatScore");
      if (loc_set_chatScore !== null) {
        var dtm_old = JSON.parse(loc_set_chatScore);
        var dtm = Date.now();
        var timeDiff = dtm - dtm_old; // 计算时间差

        if (timeDiff < 24 * 60 * 60 * 1000) {
          this.$toast.center("每天只能修改一次哦~");
          return false;
        }
      }

      var self = this;
      var uid = this.$store.state.uid;
      var chat_mny_score = this.chat_mny_score;
      var send_data = { chat_mny_score: chat_mny_score };
      var data = {
        url: "/App/User_ModifyBaseInfo",
        data: {
          uid: uid,
          data: JSON.stringify(send_data),
        },
        success: function (data_serve) {
          if (data_serve.state == "1") {
            self.$toast.center("设置成功");
            localStorage.setItem("loc_set_chatScore", JSON.stringify(Date.now()));
            self.act_reload_userinfo();
          }
         },
      };
      self.post(data);
    },
    more_setMny() {
      this.$router.push({name: "charge"});
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #EFEFEF;
  background-size: 100% 100%;
  .nav-top {
    background-color: #8A61FF;
  }
  .nav-right {
    padding-right: 0.5rem;
    .nav-lable {
      margin: 0;
      font-size: 0.9rem;
      color: #fff;
    }
  }

  .top {
    padding: 1rem 0.8rem;
    background-color: #8A61FF;
    background-image: linear-gradient(to bottom, #8A61FF, #FE9CC0);
    .sum-score {
      span {
        font-size: 1.7rem;
        font-weight: bold;
        color: #FFF;
      }
      a {
        margin-left: 0.1rem;
        font-size: 0.9rem;
        color: #FFF;
        line-height: 1.6rem;
      }
    }
    ul {
      margin-top: 1rem;
      width: 100%;
    }
    .item {
      .num {
        font-size: 1.2rem;
        color: #f7f2f2;
      }
      .score {
        margin-top: 0.3rem;
        font-size: 0.6rem;
        color: #f3bfe8;
      }
    }
  }

  .tasks-box{
    padding: 0 0.75rem;
    background: linear-gradient(to bottom, #FE9CC0, #fff 40rem);
    .tasks-list{
      border-radius: 0.5rem;
      background-color: #FDFDFD;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        color: #333;
        padding: 1rem;
          .integral {
            width: 2.1rem;
            height: 2.1rem;
            background-color: #DFD0FF;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 0.5rem;
              img {
                width: 1rem;
                height: 1rem;
              }
              
            }
            .score {
              flex: 1;
              padding: 0 1rem;
            }
            .reward {
                font-size: 0.9rem;
            }
            .reward-no {
              font-size: 0.9rem;
              color: #a0a0a0;
            }
          .integrals {
                margin-top: 0.3rem;
                line-height: 1.2rem;
                font-size: 0.75rem;
                color: #808080;
          }
          
      }
      .line{
        margin: 0 1rem;
        border-top: 1px solid #EFEFEF;
      }
    }
  }
  .task-tips {
    margin-top: 2rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
    color: #f31b4a;
    font-size: 0.75rem;
  }
  .chat-tasks {
    margin-top: 0.5rem;
    padding: 0.5rem 0;
    border-radius: 0.5rem;
    background-color: #FDFDFD;
    .middle-txt {
      .d1 {
        background-image: linear-gradient(to right, #EFEFEF, #ba61ff);
        height: 4px;
        width: 5rem;
      }
      .d2 {
        background-image: linear-gradient(to left, #EFEFEF, #ba61ff);
        height: 4px;
        width: 5rem;
      }
      span {
        font-size: 1.3rem;
        font-weight: bold;
        margin: 0 1.5rem;
        color: #ba61ff;
      }
    }
    .set-score {
      margin: 1rem 0;
      .item {
        width: 6rem;
        height: 6rem;
        border-radius: 0.2rem;
        border: 1px solid #9b9898;
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333;
        }
      }
      .item.selected {
        border: 1px solid rgb(186, 97, 255);
        span {
          color: rgb(186, 97, 255);
        }
      }
    }
    .set_btn {
      margin: 0.5rem 0;
      padding: 0.5rem 8rem;
      border-radius: 2rem;
      background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
      span {
        font-size: 0.9rem;
        font-weight: bold;
        color: #FFFFFF;
      }
    }
    
  }
  .more_set {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      font-size: 0.75rem;
      color: #ba61ff;
    }
  .btn {
    font-size: 0.65rem;
    font-weight: 500;
    border: none;
    border-radius: 1rem;
    width: 4.1rem;
    height: 1.75rem;
  }
  .btn-1 {
    min-width: 4.1rem;
    white-space: nowrap;
    background-color: transparent;
    border: 1px solid rgb(186, 97, 255);
    color: rgb(186, 97, 255);
  }
  .btn-2 {
      background-image: linear-gradient(to bottom,#2cac32,#59e064);
       color: #FFFFFF;
  }
  .btn-22 {
      background-image: linear-gradient(to bottom,#8A61FF,#FE9CC0);
      color: #FFFFFF;
   }
   .btn-3 {
       background-color: #E9E9E9;
       color: #898989;
   }
   .btn-5 {
     background-color: #E9E9E9;
     color: #e92162;
   }
}

.set_tips {
  font-size: 0.75rem;
  color: #e92162;
}

.tips {
  margin: 0.5rem 0;
  font-size: 0.6rem;
  color: #bfbaba;
}

.xhc_tip {
  margin: 1rem 0;
  font-size: 0.6rem;
  color: #bfbaba;
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .nav-top {
    background-color: #3c296e;
  }
  .top {
    background-image: linear-gradient(to bottom, #3c296e, #5f3b48);
    .item {
      .num {
        color: #e5e5e5;
      }
      .score {
        color: #808080;
      }
    }
  }
  .tasks-box {
    background: linear-gradient(to bottom, #5f3b48, #2F2E33 40rem);
    .tasks-list {
      background-color: #2c2b30;
      .item {
        color: #FDFDFD;
        
      }
      .line{
        margin: 0 1rem;
        border-top: 1px solid #404040;
      }
    }
  }
  .chat-tasks {
    background-color: #2c2b30;
    .middle-txt {
      .d1 {
        background-image: linear-gradient(to right, #2F2E33, #ba61ff);
      }
      .d2 {
        background-image: linear-gradient(to left, #2F2E33, #ba61ff);
      }
    }
    .set-score {
      .item {
        span {
          color: #FDFDFD;
        }
      }
    }
  }
  .btn-1 {
    color: #FDFDFD;
  }
  .tips {
    color: #656161;
  }
  .xhc_tip {
    color: #656161;
  }
}

</style>
